import QuizForm from "../../../components/admin/quizzes/QuizForm";

function AddQuiz() {
  return (
    <main
      className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B] mt-8 space-y-6"
      style={{ width: "75%" }}
    >
      <h1 className="mb-10 text-center lws-section-title">Add New Quiz</h1>

      <div className="max-w-3xl mx-auto">
        <QuizForm initialData={{}} />
      </div>
    </main>
  );
}

export default AddQuiz;
